/* esm.sh - unhead@2.1.12/dist/shared/unhead.BYvz9V1x */
export * from "/*unhead@2.1.12/esnext/dist/shared/unhead.BYvz9V1x.mjs";
